import MultiVideo from './multi-video';

export default MultiVideo;
